export const FILTERS = {
  cropType: 'cropType',
  year: 'year',
  mapLayer: 'mapLayer',
  soilType: 'soilType',
  seedDate: 'seedDate',
  harvestDate: 'harvestDate',
  coverCrop: 'coverCrop',
  preCrop: 'preCrop',
};

export const SEED_DATE_CODES = {
  ALL: 'All',
};

export const SEED_DATE_TYPES = [
  {
    code: SEED_DATE_CODES.ALL,
    id: SEED_DATE_CODES.ALL,
    names: { de: 'Alle' },
  },
  {
    code: 'normal',
    id: 'normal',
    names: { de: 'Normal' },
  },
  {
    code: 'late',
    id: 'late',
    names: { de: 'Spät' },
  },
  {
    code: 'early',
    id: 'early',
    names: { de: 'Früh' },
  },
];

export const HARVEST_DATE_CODES = {
  ALL: 'All',
};

export const HARVEST_DATE_TYPES = [
  {
    code: HARVEST_DATE_CODES.ALL,
    id: HARVEST_DATE_CODES.ALL,
    names: { de: 'Alle' },
  },
  {
    code: 'normal',
    id: 'normal',
    names: { de: 'Normal' },
  },
  {
    code: 'late',
    id: 'late',
    names: { de: 'Spät' },
  },
  {
    code: 'early',
    id: 'early',
    names: { de: 'Früh' },
  },
];

export const COVER_CROP_CODES = {
  ALL: 'All',
};

export const COVER_CROP_TYPES = [
  {
    code: COVER_CROP_CODES.ALL,
    id: COVER_CROP_CODES.ALL,
    names: { de: 'Alle' },
  },
  {
    code: 'cc',
    id: 'cc',
    names: { de: 'Ja' },
  },
  {
    code: 'nc',
    id: 'nc',
    names: { de: 'Nein' },
  },
];

export const getSeedDateTypeByCode = (code) => {
  return SEED_DATE_TYPES.filter((seedDate) => seedDate.code === code)[0]?.names?.de;
};

export const getHarvestDateTypeByCode = (code) => {
  return HARVEST_DATE_TYPES.filter((harvestDate) => harvestDate.code === code)[0]?.names?.de;
};

export const getCoverCropTypeByCode = (code) => {
  return COVER_CROP_TYPES.filter((coverCrop) => coverCrop.code === code)[0]?.names?.de;
};
